import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ModalComponent } from '@app/core/services/modal-manager/modal-component';
import { TranslateModule } from '@ngx-translate/core';
import { CertRequirementsService } from './cert-requirements.service';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { SharedModule } from '@app/shared/shared.module';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { environment } from '@env/environment';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule, PipesModule, SharedModule, LocalizeRouterModule, RouterModule],
  selector: 'cert-requirements',
  templateUrl: './cert-requirements.component.html',
  styleUrls: ['./cert-requirements.component.scss'],
})
export class CertRequirementsComponent extends ModalComponent {
  isProduction = environment.production;
  service = inject(CertRequirementsService);
  trainingLevels() {
    return this.service.cert?.training_levels.map((l) => l.title).join(', ');
  }
  openFeedback() {
    let url = `/certifications/${this.service.cert?.id}/`;
    if (this.service.cert?.type === 'instructor_certification') {
      url += 'pro-';
    }
    url += 'feedback';
    this.navDataService.navigate(url);
    this.dismiss();
  }
}
